<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      <span>Are you sure you want to delete the timesheet?</span>
    </template>
    <template v-slot:body>
      <div class="delete-timesheet-description">
        This cannot be undone.
      </div>
    </template>
    <template v-slot:actions>
      <div class="delete-timesheet-actions">
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <ErrorButton @click.native="handleSubmit" :loading="isLoading">
          Delete Timesheet
        </ErrorButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { createNamespacedHelpers } from "vuex";
import {
  DELETE_TIMESHEET,
  GET_CURRENT_TIMESHEET
} from "@/store/modules/timesheets/actions";
import { TIMESHEETS_NAMESPACE } from "@/store/modules/timesheets";

const { mapActions } = createNamespacedHelpers(TIMESHEETS_NAMESPACE);

export default {
  name: "DeleteTimesheetDialog",
  components: { ErrorButton, PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    isOpen: Boolean,
    timesheetId: {
      type: [Number, String],
      required: true
    }
  },
  methods: {
    ...mapActions({
      getCurrentTimesheet: GET_CURRENT_TIMESHEET,
      deleteTimesheet: DELETE_TIMESHEET
    }),
    async handleSubmit() {
      this.isLoading = true;
      try {
        await this.deleteTimesheet(this.timesheetId);
        this.$emit("onDelete");
      } catch {
        this.$emit("close");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
